import { abUseExperimentsSelector, isAbUseExperimentsActive } from 'shared/selectors';
import { IState } from 'shared/store';

export const NEWBUILDING_TRUST_AND_SAFETY = 'newbuilding_trust_safety_desktop';
export const selectIsNewbuildingReliabilityEnabled = (state: IState): boolean => {
  const experiments = abUseExperimentsSelector(state);

  return isAbUseExperimentsActive(experiments, NEWBUILDING_TRUST_AND_SAFETY, 'enabled');
};
